var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyMembersTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 3.5,
    r: 1.5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5.2,
    r: 2,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10.8304 6 11.6267 6.3163 12.2139 6.87891C12.552 7.20297 12.8054 7.59357 12.959 8.01855C13.0034 8.14168 13.0092 8.26108 12.9863 8.37207C12.7225 8.14118 12.3781 8 12 8C11.3471 8 10.793 8.41766 10.5869 9H9.97363C9.86928 8.87894 9.76012 8.76111 9.64355 8.64941C9.00349 8.03618 8.21697 7.60381 7.36719 7.37891C7.48723 7.19991 7.62669 7.0317 7.78613 6.87891C8.37329 6.3163 9.16964 6 10 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99954 8.2002C7.10656 8.20028 8.1689 8.622 8.95169 9.37207C9.13408 9.54689 9.29615 9.73743 9.43997 9.93848C9.16822 10.21 9.00052 10.5855 9.00052 11C9.00052 11.4063 9.163 11.7738 9.42532 12.0439C9.23666 12.142 9.01582 12.2001 8.78274 12.2002H3.21634C2.44797 12.2001 1.80383 11.5873 2.0552 10.8916C2.25996 10.325 2.59658 9.80412 3.04739 9.37207C3.83024 8.62199 4.89246 8.20021 5.99954 8.2002Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5713 11H13.5713M12.0713 9.5V12.5",
    stroke: "currentColor",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyMembersTab);
export default __webpack_public_path__ + "static/media/family-members-tab.b8b13187f9e94173cf236809430eec2c.svg";
export { ForwardRef as ReactComponent };